export { default as SystemCategoryList } from './page'


// WEBPACK FOOTER //
// ./src/pages/systemCategoryList/index.js